<template>
  <b-row>
    <b-col md="4">
      <label>Origen*</label>
    </b-col>
    <b-col md="8">
      <b-form-select v-model="oferta.origenOfertaId" :disabled="disabled">
        <b-form-select-option disabled selected value=""> Seleccione el origen de la oferta </b-form-select-option>
        <b-form-select-option v-for="origen in origenes" :key="origen.id" :value="origen.id">
          {{ origen.origen }}
        </b-form-select-option>
      </b-form-select>
    </b-col>
  </b-row>
</template>

<script>
import origenesApi from "@/services/origenOferta";
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";
export default {
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta"]),
  },
  mounted() {
    this.cargarOrigenes();
  },
  methods: {
    async cargarOrigenes() {
      this.origenes = await origenesApi.listar();
    },
  },
  data() {
    return {
      origenes: [],
    };
  },
};
</script>
